import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageTrustClubGoldCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Trust Club Gold Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/japan-trust-club-gold-card.png',
  show: true,
  position: 'right'
};

export const BannerContentTrustClubGoldCardMocks: GenericLabel = {
  title: 'Delta SkyMiles Trust Club Gold VISA Card',
  subtitle: ''
};

export const BannerTrustClubGoldCardMocks: CardCarouselBanner = {
  labels: BannerContentTrustClubGoldCardMocks,
  image: BannerImageTrustClubGoldCardMocks
};
